import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-bullet-list-2",
  "use": "icon-si-glyph-bullet-list-2-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-bullet-list-2\" id=\"icon-si-glyph-bullet-list-2\"><title>975</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 1.000000)\" fill=\"#434343\"><rect x=\"0\" y=\"0\" width=\"2\" height=\"2\" class=\"si-glyph-fill\" /><rect x=\"0\" y=\"5\" width=\"2\" height=\"2\" class=\"si-glyph-fill\" /><rect x=\"0\" y=\"10\" width=\"2\" height=\"2\" class=\"si-glyph-fill\" /><rect x=\"5\" y=\"1\" width=\"11\" height=\"1\" class=\"si-glyph-fill\" /><rect x=\"5\" y=\"6\" width=\"11\" height=\"1\" class=\"si-glyph-fill\" /><rect x=\"5\" y=\"11\" width=\"11\" height=\"1\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-bullet-list-2.svg
// module id = m8gh
// module chunks = 62